import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Toggle} from '../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {ShowTagInCellsTooltip} from '../../../components/common/dropdowns/tags/tagEditorTooltips';
import {SettingsFieldLine} from '../../common/settingsFieldLine';

/*
 * Props.
 */

interface SettingsSingleTagConversationsFieldProps {
  isChecked: boolean;
  onChange: HandlerOf<boolean>;
}

/*
 * Component.
 */

export const SettingsSingleTagConversationsField: FC<SettingsSingleTagConversationsFieldProps> = (props) => (
  <SettingsFieldLine
    renderTooltip={() => <ShowTagInCellsTooltip />}
    isTooltipMultiline
    title={<Trans id="settingstags-cells-title">Add to conversation lists</Trans>}
    subtitle={
      <Trans id="settingstags-cells-subtitle">
        Anyone with access to the tag will see it in their conversation list
      </Trans>
    }
    content={<Toggle isChecked={props.isChecked} onChange={props.onChange} />}
  />
);
